// extracted by mini-css-extract-plugin
export var skipAnimation = "_49-0";